import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import FeatherIcon from "feather-icons-react";
import FormHandler from "../shared/utils/FormHandler";
import useAuthorApi from "../apis/authorApi";
import { validateAuthor } from "../utils/FormValidationRules";

const Authors = () => {
  const { authors, createAuthor, editAuthor } = useAuthorApi();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [submitErrors, setSubmitErrors] = useState({});

  const { values, errors, handleChange, handleOnBlur, initForm } = FormHandler(
    () => {},
    validateAuthor
  );

  function resetFormData() {
    setIsModalVisible(false);
    initForm({});
    setSubmitErrors({});
  }

  const handleAddClick = () => {
    setIsUpdate(false);
    setSubmitErrors({});
    initForm({});
    setIsModalVisible(true);
  };

  const handleEditClick = (author) => {
    setIsUpdate(true);
    setSubmitErrors({});
    initForm({
      id: author._id,
      name: author.name,
      bio: author.bio,
      linkedin_url: author.linkedin_url,
    });
    setIsModalVisible(true);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    const formErrors = validateAuthor(values);
    setSubmitErrors(formErrors);
    if (Object.keys(formErrors).length > 0) {
      return;
    }

    if (isUpdate) {
      editAuthor(
        { id: values.id, name: values.name, bio: values.bio, linkedin_url: values.linkedin_url },
        resetFormData
      );
    } else {
      createAuthor(
        { name: values.name, bio: values.bio, linkedin_url: values.linkedin_url },
        resetFormData
      );
    }
  };

  return (
    <div>
      <Container>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="innovation-title">Authors</h2>
          <button onClick={handleAddClick} className="sa-table-btn-secondary" style={{ width: "200px" }}>
            <FeatherIcon icon={"plus"} className={"sa-table-icon-size"} />{" "}
            <span className={"sa-table-icon"}>ADD AUTHOR</span>
          </button>
        </div>

        <div className="sa-table-container">
          <table className="table table-borderless sa-table-width">
            <thead>
              <tr>
                <th className={"sa-table-head-sticky"}>Name</th>
                <th className={"sa-table-head-sticky"}>Bio</th>
                <th className={"sa-table-head-sticky"}>LinkedIn</th>
                <th className="sa-table-item-align sa-table-head-sticky"></th>
              </tr>
            </thead>
            <tbody>
              {authors.length === 0 ? (
                <tr>
                  <td colSpan="4" className={"sa-table-data"}>
                    No authors yet
                  </td>
                </tr>
              ) : (
                authors.map((author) => (
                  <tr key={author._id}>
                    <td className={"sa-table-data"}>{author.name}</td>
                    <td className={"sa-table-data"}>{author.bio}</td>
                    <td className={"sa-table-data"}>
                      {author.linkedin_url && (
                        <a href={author.linkedin_url} target="_blank" rel="noopener noreferrer">
                          {author.linkedin_url}
                        </a>
                      )}
                    </td>
                    <td className="sa-table-item-align">
                      <div className={"sa-table-action-flex"}>
                        <div
                          className="sa-table-actions sa-action-m"
                          data-toggle="tooltip"
                          title="Edit"
                        >
                          <FeatherIcon
                            onClick={() => handleEditClick(author)}
                            className="table-action"
                            icon={"edit"}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Container>

      <div className={"sa-popup-bg " + (!isModalVisible && "hide")}>
        <div className="sa-popup">
          <form onSubmit={handleFormSubmit} className={"sa-modal-box-style"}>
            <div className="sa-popup-header">
              <span className={"sa-model-heading"}>
                {!isUpdate ? "ADD AUTHOR" : "EDIT AUTHOR"}
              </span>
              <div className="sa-popup-close-icon" onClick={resetFormData}>
                <FeatherIcon className={"sa-modal-close-icon"} icon={"x"} />
              </div>
            </div>
            <div className="sa-popup-content">
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    name="name"
                    value={values.name || ""}
                    onChange={handleChange}
                    onBlur={handleOnBlur}
                    className={
                      errors.name || submitErrors.name
                        ? "form-control warning-input"
                        : "form-control"
                    }
                  />
                  {(errors.name || submitErrors.name) && (
                    <p className="warning-input-msg">{errors.name || submitErrors.name}</p>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="linkedin_url">LinkedIn URL</label>
                  <input
                    type="text"
                    name="linkedin_url"
                    placeholder="https://linkedin.com/in/…"
                    value={values.linkedin_url || ""}
                    onChange={handleChange}
                    onBlur={handleOnBlur}
                    className={
                      errors.linkedin_url || submitErrors.linkedin_url
                        ? "form-control warning-input"
                        : "form-control"
                    }
                  />
                  {(errors.linkedin_url || submitErrors.linkedin_url) && (
                    <p className="warning-input-msg">
                      {errors.linkedin_url || submitErrors.linkedin_url}
                    </p>
                  )}
                </div>
              </div>

              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor="bio">Short Bio</label>
                  <textarea
                    name="bio"
                    rows={3}
                    value={values.bio || ""}
                    onChange={handleChange}
                    onBlur={handleOnBlur}
                    className="form-control"
                  />
                </div>
              </div>
            </div>

            <div className="sa-popup-btn">
              <button
                type={"button"}
                className="sa-popup-secondary-btn-style sa-popup-cancel-btn-style"
                onClick={resetFormData}
              >
                CANCEL
              </button>
              <button type="submit" className="sa-popup-secondary-btn-style">
                {!isUpdate ? "ADD" : "UPDATE"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Authors;
